import { api_host,api_auth, tokenDuoc, key_auth} from '../common/constants';

export const getAvailabilityCustomObjective = (objetivo_id, node, begin, final) => 
fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadGlobalObjetivoCustom/?objetivoId=${objetivo_id}&horarioId=0&token=${tokenDuoc}&key=${key_auth}&fechaInicio=${begin}&fechaTermino=${final}&nodoId=${node}`)
.then(response => response.json())